export default __webpack_public_path__ + "static/media/servo.04df8fac.svg";